import { useMemo } from 'react';

import InsightsTabsFilterBar from 'components/insights/filterBar/InsightsTabsFilterBar';
import { FilterSection } from 'components/shared/filters/FilterSlideout';
import { TabType } from 'components/Tabs';
import { SENDING_GROUP_TYPE, SENDING_LOCATION } from 'constants/filterKeysConstants';
import { useReferralsInsightsActions, useReferralsInsightsStore } from 'stores/referralsInsightsStore';

import { filtersForGroupType, getFilterSections } from '../../filters';
import { useReferralsInsightsContext } from '../ReferralsContainer';

type ReferralsFilterBarProps = {
  tabs: TabType[];
  selectedTab?: TabType;
  onTabClick: (tab: TabType) => void;
};

export default function ReferralsFilterBar({ tabs, selectedTab, onTabClick }: ReferralsFilterBarProps) {
  const { predecessorGroupTypes } = useReferralsInsightsContext();
  const selectedReceivingGroupType = useReferralsInsightsStore((state) => state.selectedReceivingGroupType);
  const filters = useReferralsInsightsStore((state) => state.filters);
  const { setSelectedFilters } = useReferralsInsightsActions();

  const filterSections = useMemo(
    () =>
      getFilterSections({
        predecessorGroupTypes,
        selectedGroupType: selectedReceivingGroupType,
        predecessorLocationFilterKey: SENDING_LOCATION,
        predecessorGroupTypeFilterKey: SENDING_GROUP_TYPE,
      }),
    [predecessorGroupTypes, selectedReceivingGroupType]
  );

  const activeFilters = useMemo(
    () =>
      selectedReceivingGroupType
        ? filtersForGroupType(filters, selectedReceivingGroupType, SENDING_LOCATION, SENDING_GROUP_TYPE)
        : filters,
    [filters, selectedReceivingGroupType]
  );

  return (
    <InsightsTabsFilterBar
      title='Referral Coordination'
      gtmPrefix='insightsReferrals'
      tabs={tabs}
      selectedTab={selectedTab}
      onTabClick={onTabClick}
      filters={activeFilters}
      filterSections={filterSections as FilterSection[]}
      setSelectedFilters={setSelectedFilters}
    />
  );
}
